export const getFilteredURLParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('identityToken');
  return urlParams.toString();
};
